import { apiPatch } from "./Api/apiCall";
import { AiChatFeedbackCategory, AiChatFeedbackDraft, AiChatFeedbackRating } from "../types/AIChat/AiChatFeedback";
import { AiChatMessage } from "../types/AIChat/AiChatMessage";

export const AI_CHAT_FEEDBACK_CATEGORY_LABELS: Record<AiChatFeedbackCategory, string> = {
  legallyIncorrect: "Rechtlich nicht korrekt",
  factsMisunderstood: "Sachverhalt falsch verstanden",
  caseContentNotConsidered: "Akteninhalt oder Dokumente nicht berücksichtigt",
  instructionNotFullyFollowed: "Meine Anweisung wurde nicht vollständig befolgt",
  answerIncomplete: "Antwort ist unvollständig",
  fabricatedOrUnsubstantiated: "Informationen wurden erfunden oder sind nicht belegt",
  sourceOrQuoteIncorrect: "Quelle, Fundstelle oder Zitat ist falsch",
  styleOrToneInappropriate: "Unpassender Stil oder Ton",
  tooLongOrComplex: "Antwort ist zu lang oder unnötig kompliziert",
  actionsNotSensible: "Vorgeschlagene Aktionen machen keinen Sinn",
  incorrectLegalbirdWorkflowHandling: "Fehlerhafter Umgang mit Legalbird workflow",
  other: "Sonstiges",
};

export const createAiChatFeedbackDraft = (
  message: AiChatMessage,
  rating: AiChatFeedbackRating,
): AiChatFeedbackDraft => ({
  rating,
  category: rating === "negative" ? (message.feedbackCategory ?? "other") : null,
  comment: message.feedbackComment ?? "",
});

//merge-patch keeps omitted keys, so all three fields are always sent explicitly
export const buildAiChatFeedbackPayload = (draft: AiChatFeedbackDraft) => {
  const comment = draft.comment.trim();

  return {
    feedbackRating: draft.rating,
    feedbackCategory: draft.rating === "negative" ? draft.category : null,
    feedbackComment: comment === "" ? null : comment,
  };
};

export const saveAiChatFeedback = (messageId: number, draft: AiChatFeedbackDraft): Promise<AiChatMessage> =>
  apiPatch("ai_chat_messages", messageId, buildAiChatFeedbackPayload(draft));
